/**
 * @Author fxg1997
 * @version 1.0
*/
export const ICPS = [{
  path: '/lvshe',
  component: () => import('@/views/pages/pages.vue'),
  children: [{
    path: 'icps',
    component: () => import('@/views/platform/platform'),
    children: [
      {
        path: "outUrl",
        name: "outUrl",
        component: () => import("@/views/platform/outUrl"),
        meta: {
          title: "外部链接",
          system: "outUrl",
          keepAlive: false
        },
      },
      {
        path: "ICPSIndex",
        name: "ICPSIndex",
        component: () =>
          import(/* webpackChunkName: 'huanyin'*/
            "@/views/platform/ICPS/index.vue"
          ),
        meta: {
          title: "欢迎使用ICPS",
          system: "basicSite",
          keepAlive: false
        },
      },
      {
        path: 'basicSite',
        name: 'basicSite',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/site.vue'),
        meta: {
          title: '站点维护',
          system: 'basicSite',
          keepAlive: false
        }
      },
      {
        path: 'basiccar',
        name: 'basiccar',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/car.vue'),
        meta: {
          title: '车辆维护',
          system: 'basicSite',
          keepAlive: false
        }
      },
      {
        path: 'basicEquipmente',
        name: 'basicEquipmente',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/equipment.vue'),
        meta: {
          title: '泵车维护',
          system: 'basicSite',
          keepAlive: false
        }
      },
      {
        path: 'carEquipmentManagement',
        name: 'carEquipmentManagement',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/carEquipmentManagement.vue'),
        meta: {
          title: '车载设备维护',
          system: 'basicSite',
          keepAlive: false
        }
      },
      {
        path: 'basicotherEquipmente',
        name: 'basicotherEquipmente',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/otherEquipmente.vue'),
        meta: {
          title: '计量设备维护',
          system: 'basicSite',
          keepAlive: false
        }
      },
      {
        path: 'basicspringback',
        name: 'basicspringback',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/springback.vue'),
        meta: {
          title: '回弹仪维护',
          system: 'basicSite',
          keepAlive: false
        }
      },
      {
        path: 'basicotherSE',
        name: 'basicotherSE',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/otherSE.vue'),
        meta: {
          title: '其他设备维护',
          system: 'basicSite',
          keepAlive: false
        }
      },
      {
        path: 'basicRmaterial',
        name: 'basicRmaterial',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/Rmaterial.vue'),
        meta: {
          title: '原物料维护',
          system: 'basicSite',
          keepAlive: false
        }
      },
      {
        path: 'basicCCTrules',
        name: 'basicCCTrules',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/CCTrules.vue'),
        meta: {
          title: '混凝土产品命名规则',
          system: 'basicSite',
          keepAlive: false
        }
      },
      {
        path: 'mixForm',
        name: 'mixForm',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/mixForm.vue'),
        meta: {
          title: '配合比库',
          system: 'basicSite',
          keepAlive: false
        }
      },
      {
        path: 'mixIssue',
        name: 'mixIssue',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/mixIssue.vue'),
        meta: {
          title: '配合比下发',
          system: 'basicSite',
          keepAlive: true
        }
      },
      {
        path: 'binInspection',
        name: 'binInspection',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/binInspection.vue'),
        meta: {
          title: '料仓巡检',
          keepAlive: true,
          system: 'basicSite'
        }
      },
      {
        path: 'basicCPYquality',
        name: 'basicCPYquality',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/CPYquality.vue'),
        meta: {
          title: '公司质量参数',
          system: 'basicSite',
          keepAlive: false
        }
      },
      {
        path: 'sign_CPYquality',
        name: 'sign_CPYquality',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/sign/sign_CPYquality.vue'),
        meta: {
          title: '公司质量参数审批',
          system: 'basicSite',
        }
      },
      {
        path: 'basicSitequality',
        name: 'basicSitequality',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/Sitequality.vue'),
        meta: {
          title: '站点质量参数',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'sign_Sitequality',
        name: 'sign_Sitequality',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/sign/sign_Sitequality.vue'),
        meta: {
          title: '站点质量参数审批',
          system: 'basicSite',
        }
      },
      {
        path: 'basicnotice',
        name: 'basicnotice',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/notice.vue'),
        meta: {
          title: '通知维护',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'basicmix',
        name: 'basicmix',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/mix.vue'),
        meta: {
          title: '站点配合比',
          system: 'basicSite'
        }
      },
      {
        path: 'sign_mix',
        name: 'sign_mix',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/sign/sign_mix.vue'),
        meta: {
          title: '站点配合比审批',
          system: 'basicSite',
        }
      },
      {
        path: 'companyStandard',
        name: 'companyStandard',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/companyStandard.vue'),
        meta: {
          title: '公司标准产品配合比',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'basicproflow',
        name: 'basicproflow',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/proflow.vue'),
        meta: {
          title: '工艺流程',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'editTicketTemplate',
        name: 'editTicketTemplate',
        hidden: true,
        component: () => import(
          '@/views/platform/ICPS/basicConfig/editTicketTemplate.vue'),
        meta: {
          title: '模板管理',
          // keepAlive: true,
          system: 'basicSite'
        }
      },
      {
        path: 'ticketTemplate',
        name: 'ticketTemplate',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/ticketTemplate.vue'),
        meta: {
          title: '小票模板管理',
          // keepAlive: true,
          system: 'basicSite'
        }
      },
      {
        path: 'basicbarcode',
        name: 'basicbarcode',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/barcode.vue'),
        meta: {
          title: '条码维护',
          // keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'basicfactor',
        name: 'basicfactor',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/factor.vue'),
        meta: {
          title: '评估因子维护',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'basicpriceMaintenance',
        name: 'basicpriceMaintenance',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/priceMaintenance.vue'),
        meta: {
          title: '标号信息价维护',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'basicAbnormal',
        name: 'basicAbnormal',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/abnormal.vue'),
        meta: {
          title: '基础调价维护',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      // 绿舍云销
      {
        path: 'customerManagement',
        name: 'customerManagement',
        component: () => import(
          '@/views/platform/ICPS/internetSales/customer.vue'),
        meta: {
          title: '客户维护',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'customerManagementProduction',
        name: 'customerManagementProduction',
        component: () => import(
          '@/views/platform/ICPS/internetSales/customerProduction.vue'),
        meta: {
          title: '生产处客户管理',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'internetSalessalesoppo',
        name: 'internetSalessalesoppo',
        component: () => import(
          '@/views/platform/ICPS/internetSales/salesoppo.vue'),
        meta: {
          title: '机会维护',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'chanceManagement',
        name: 'chanceManagement',
        component: () => import(
          '@/views/platform/ICPS/internetSales/chanceManagement.vue'),
        meta: {
          title: '销售机会',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'projectManagement',
        name: 'projectManagement',
        component: () => import(
          '@/views/platform/ICPS/internetSales/projectManagement.vue'),
        meta: {
          title: '工程维护',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'projectAssess',
        name: 'projectAssess',
        component: () => import(
          '@/views/platform/ICPS/internetSales/projectAssess.vue'),
        meta: {
          title: '工程评估',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'EngineeringEvaluation',
        name: 'EngineeringEvaluation',
        component: () => import(
          '@/views/platform/ICPS/internetSales/flowscomponent/EngineeringEvaluation.vue'),
        meta: {
          title: '工程评估审核',
          system: 'basicSite',
        }
      },
      // {
      //   path: 'assess',
      //   name: 'assess',
      //   component: () => import(
      //     '@/views/platform/ICPS/internetSales/sign/assess.vue'),
      //   meta: {
      //     title: '工程评估登记',
      //     system: 'basicSite'
      //   }
      // },
      {
        path: 'internetSalestender',
        name: 'internetSalestender',
        component: () => import(
          '@/views/platform/ICPS/internetSales/tender.vue'),
        meta: {
          title: '工程投标',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'projectClarifi',
        name: 'projectClarifi',
        component: () => import(
          '@/views/platform/ICPS/internetSales/projectClarifi.vue'),
        meta: {
          title: '工程交底',
          // keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'ProjectClarifiFlow',
        name: 'ProjectClarifiFlow',
        component: () => import(
          '@/views/platform/ICPS/internetSales/components/ProjectClarifiFlow.vue'),
        meta: {
          title: '工程交底审核',
          system: 'basicSite',
        }
      },
      {
        path: 'performanceRecord',
        name: 'performanceRecord',
        component: () => import(
          '@/views/platform/ICPS/internetSales/performanceRecord.vue'),
        meta: {
          title: '工程履约',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: "CoordinationBody",
        name: "CoordinationBody",
        component: () =>
          import(/* webpackChunkName: 'basicData1'*/
            "@/views/platform/platform_item/basicData/dictionary/dictionary.vue"
          ),
        meta: {
          title: "协调主体字典管理",
          system: "organization",
          keepAlive: false,
        },
      },
      {
        path: 'monthlyReportUnitRecord',
        name: 'monthlyReportUnitRecord',
        component: () => import(
          '@/views/platform/ICPS/internetSales/monthlyReportUnitRecord.vue'),
        meta: {
          title: '月报单价确认',
          keepAlive: true,
          system: 'basicSite'
        }
      },
      {
        path: 'monthlyReportList',
        name: 'monthlyReportList',
        component: () => import(
          '@/views/platform/ICPS/internetSales/monthlyReportList.vue'),
        meta: {
          title: '月报列表',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'mouthReportRecordList',
        name: 'mouthReportRecordList',
        component: () => import(
          '@/views/platform/ICPS/internetSales/mouthReportRecordList.vue'),
        meta: {
          title: '月报单价确认-生成列表',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'RiskControlFlow',
        name: 'RiskControlFlow',
        component: () => import(
          '@/views/platform/ICPS/internetSales/flowscomponent/RiskControlFlow.vue'),
        meta: {
          title: '风险管控审批',
          system: 'basicSite',
        }
      },
      {
        path: 'engineeringControl',
        name: 'engineeringControl',
        component: () => import(
          '@/views/platform/ICPS/internetSales/engineeringControl.vue'),
        meta: {
          title: '工程调价',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'priceMaintenance_sign',
        name: 'priceMaintenance_sign',
        component: () => import(
          '@/views/platform/ICPS/internetSales/dialog/priceMaintenance_sign.vue'),
        meta: {
          title: '工程调价审批',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'engineeringNotes',
        name: 'engineeringNotes',
        component: () => import(
          '@/views/platform/ICPS/internetSales/engineeringNotes.vue'),
        meta: {
          title: '发票出具',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'projectPayment',
        name: 'projectPayment',
        component: () => import(
          '@/views/platform/ICPS/internetSales/projectPayment.vue'),
        meta: {
          title: '工程收款',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'overdueSupplyReview',
        name: 'overdueSupplyReview',
        component: () => import(
          '@/views/platform/ICPS/internetSales/supplyManagement/itemPayment/overdueSupplyReview.vue'),
        meta: {
          title: '欠供复审',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'overdueSupplyReviewDetail',
        name: 'overdueSupplyReviewDetail',
        component: () => import(
          '@/views/platform/ICPS/internetSales/supplyManagement/itemPayment/overdueSupplyReviewDetail.vue'),
        meta: {
          title: '复审清单',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'overdueSupplyReviewApproval',
        name: 'overdueSupplyReviewApproval',
        component: () => import(
          '@/views/platform/ICPS/internetSales/supplyManagement/itemPayment/overdueSupplyReviewApproval.vue'),
        meta: {
          title: '风控复审',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'debtSupplyDetail',
        name: 'debtSupplyDetail',
        component: () => import(
          '@/views/platform/ICPS/internetSales/supplyManagement/itemPayment/debtSupplyDetail.vue'),
        meta: {
          title: '欠款供应清单',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'debtSupplyDetailApproval',
        name: 'debtSupplyDetailApproval',
        component: () => import(
          '@/views/platform/ICPS/internetSales/supplyManagement/itemPayment/debtSupplyDetailApproval.vue'),
        meta: {
          title: '欠款供应清单审批',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'SupplyControlSet',
        name: 'SupplyControlSet',
        component: () => import(
          '@/views/platform/ICPS/internetSales/supplyManagement/controlSet/SupplyControlSet.vue'),
        meta: {
          title: '供应管控参数',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'processDifferControl',
        name: 'processDifferControl',
        component: () => import(
          '@/views/platform/ICPS/internetSales/supplyManagement/contractPerformance/processDifferControl.vue'),
        meta: {
          title: '过程量差管控',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'processDifferControlApproval',
        name: 'processDifferControlApproval',
        component: () => import(
          '@/views/platform/ICPS/internetSales/supplyManagement/contractPerformance/processDifferControlApproval.vue'),
        meta: {
          title: '过程量差管控审批',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'superGraphCalculation',
        name: 'superGraphCalculation',
        component: () => import(
          '@/views/platform/ICPS/internetSales/supplyManagement/contractPerformance/superGraphCalculation.vue'),
        meta: {
          title: '超图算管控',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'superGraphCalculationApproval',
        name: 'superGraphCalculationApproval',
        component: () => import(
          '@/views/platform/ICPS/internetSales/supplyManagement/contractPerformance/superGraphCalculationApproval.vue'),
        meta: {
          title: '超图算管控审批',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'exceedContractControl',
        name: 'exceedContractControl',
        component: () => import(
          '@/views/platform/ICPS/internetSales/supplyManagement/contractPerformance/exceedContractControl.vue'),
        meta: {
          title: '超合同管控',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'ExceedContractApproval',
        name: 'ExceedContractApproval',
        component: () => import(
          '@/views/platform/ICPS/internetSales/supplyManagement/contractPerformance/ExceedContractApproval.vue'),
        meta: {
          title: '超合同管控审批',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'preCommissioning',
        name: 'preCommissioning',
        component: () => import(
          '@/views/platform/ICPS/internetSales/supplyManagement/preparatoryCommission/preCommissioning.vue'),
        meta: {
          title: '委托管控',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'PreCommissioningApproval',
        name: 'PreCommissioningApproval',
        component: () => import(
          '@/views/platform/ICPS/internetSales/supplyManagement/preparatoryCommission/PreCommissioningApproval.vue'),
        meta: {
          title: '委托管控审批',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      /*绿舍数采*/
      {
        path: 'GHnumberSupplier',
        name: 'GHnumberSupplier',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/supplier.vue'),
        meta: {
          title: '供应商管理',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'ChangeLevelCoop',
        name: 'ChangeLevelCoop',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/flowcomponent/ChangeLevelCoop.vue'),
        meta: {
          title: '合作等级审核',
          system: 'basicSite',
        }
      },
      {
        path: 'SupplierRating',
        name: 'SupplierRating',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/flowcomponent/SupplierRating.vue'),
        meta: {
          title: '供应商评价审核',
          system: 'basicSite',
        }
      },
      {
        path: 'queryContractAll',
        name: 'queryContractAll',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/contract/queryContractAll.vue'),
        meta: {
          title: '合同查询',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'GHnumberContractcontract',
        name: 'GHnumberContractcontract',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/contract/contract.vue'),
        meta: {
          title: '原物料',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'GHnumberContractcar',
        name: 'GHnumberContractcar',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/contract/car.vue'),
        meta: {
          title: '车辆外包',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'GHnumberContractequipment',
        name: 'GHnumberContractequipment',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/contract/equipment.vue'),
        meta: {
          title: '设备外包',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'GHnumberContractpumpTube',
        name: 'GHnumberContractpumpTube',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/contract/pumpTube.vue'),
        meta: {
          title: '泵管外包',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'GHnumberContractoutsourcing',
        name: 'GHnumberContractoutsourcing',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/contract/outsourcing.vue'),
        meta: {
          title: '外协合同',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'GHnumberContractsourcingout',
        name: 'GHnumberContractsourcingout',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/contract/sourcingout.vue'),
        meta: {
          title: '协外合同',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'GHnumberContractinternalunit',
        name: 'GHnumberContractinternalunit',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/contract/internalunit.vue'),
        meta: {
          title: '内部单位合同',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'GHnumberContractinfrastructure',
        name: 'GHnumberContractinfrastructure',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/contract/infrastructure.vue'),
        meta: {
          title: '基建及设备项目合同',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'signContract',
        name: 'signContract',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/signContract/signContract.vue'),
        meta: {
          title: '合同审批',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'firstSupplyEngineering',
        name: 'firstSupplyEngineering',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/firstSupplyEngineering.vue'),
        meta: {
          title: '甲供工程',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'GHnumberShare',
        name: 'GHnumberShare',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/share.vue'),
        meta: {
          title: '份额维护',
          keepAlive: false,
          system: 'basicSite'
        }
      },
      {
        path: 'ShareMaintenance',
        name: 'ShareMaintenance',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/flowcomponent/ShareMaintenance.vue'),
        meta: {
          title: '份额维护审核',
          system: 'basicSite',
        }
      },
      {
        path: 'GHnumberDSP',
        name: 'GHnumberDSP',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/DSP.vue'),
        meta: {
          title: '采购审批',
          system: 'basicSite'
        }
      },
      {
        path: 'GHnumberSPratio',
        name: 'GHnumberSPratio',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/SPratio.vue'),
        meta: {
          title: '站点配比维护',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'SiteProportion',
        name: 'SiteProportion',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/flowcomponent/SiteProportion.vue'),
        meta: {
          title: '站点采购配合比审批',
          system: 'basicSite',
        }
      },
      {
        path: 'GHnumberDSPplorder',
        name: 'GHnumberDSPplorder',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/DSPplorder.vue'),
        meta: {
          title: '额外采购下单',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'PurchaseOrder',
        name: 'PurchaseOrder',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/flowcomponent/PurchaseOrder.vue'),
        meta: {
          title: '额外采购下单审批',
          system: 'basicSite',
        }
      },
      {
        path: 'sellMaterialTask',
        name: 'sellMaterialTask',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/sellMaterialTask.vue'),
        meta: {
          title: '售料任务',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'AddOrder',
        name: 'AddOrder',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/flowcomponent/AddOrder.vue'),
        meta: {
          title: '原物料追加计划审批',
          system: 'basicSite',
        }
      },
      {
        path: 'GHnumberDemand',
        name: 'GHnumberDemand',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/demand.vue'),
        meta: {
          title: '供应清单',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'GHnumberGoods',
        name: 'GHnumberGoods',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/goods.vue'),
        meta: {
          title: '收货查询',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'returnGoodsTask',
        name: 'returnGoodsTask',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/returnGoodsTask.vue'),
        meta: {
          title: '退货任务',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'weightTask',
        name: 'weightTask',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/weightTask.vue'),
        meta: {
          title: '过磅任务',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'cancleOrder',
        name: 'cancleOrder',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/cancleOrder'),
        meta: {
          title: '退货审批',
          system: 'basicSite',
        }
      },
      {
        path: 'GHnumberevaquery',
        name: 'GHnumberevaquery',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/evaquery.vue'),
        meta: {
          title: '供应商评价查询',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'GHnumbertransfers',
        name: 'GHnumbertransfers',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/transfers.vue'),
        meta: {
          title: '原物料调拨',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      /*供应商*/
      {
        path: 'concreteOrder',
        name: 'concreteOrder',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/concreteOrder.vue'),
        meta: {
          title: '混凝土订单',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'supplierCar',
        name: 'supplierCar',
        component: () => import(
          '@/views/platform/ICPS/supplier/car.vue'),
        meta: {
          title: '车辆维护',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'supplierEquipment',
        name: 'supplierEquipment',
        component: () => import(
          '@/views/platform/ICPS/supplier/equipment.vue'),
        meta: {
          title: '泵车维护',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'supplierPlan',
        name: 'supplierPlan',
        component: () => import(
          '@/views/platform/ICPS/supplier/plan.vue'),
        meta: {
          title: '供应清单',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'CarTransfer',
        name: 'CarTransfer',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/flowcomponent/CarTransfer.vue'),
        meta: {
          title: '车辆转派审批',
          system: 'basicSite',
        }
      },
      {
        path: 'QIUBO_SCM_TEST',
        name: 'QIUBO_SCM_TEST',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/flowcomponent/QIUBO_SCM_TEST.vue'),
        meta: {
          title: '流程测试',
          system: 'basicSite',
        }
      },
      {
        path: 'QIUBO_SCM_TEST2',
        name: 'QIUBO_SCM_TEST2',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/flowcomponent/QIUBO_SCM_TEST2.vue'),
        meta: {
          title: '流程测试2',
          system: 'basicSite',
        }
      },
      {
        path: 'supplierEvaluation',
        name: 'supplierEvaluation',
        component: () => import(
          '@/views/platform/ICPS/supplier/evaluation.vue'),
        meta: {
          title: '供应评价查询',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'supplierQuery',
        name: 'supplierQuery',
        component: () => import(
          '@/views/platform/ICPS/supplier/query.vue'),
        meta: {
          title: '交货查询',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'settlement',
        name: 'settlement',
        component: () => import(
          '@/views/platform/ICPS/supplier/settlement.vue'),
        meta: {
          title: '结算确认',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'supplierReturnGoodsTask',
        name: 'supplierReturnGoodsTask',
        component: () => import(
          '@/views/platform/ICPS/supplier/supplierReturnGoodsTask.vue'),
        meta: {
          title: '退货任务',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'supplierReceiptInvoice',
        name: 'supplierReceiptInvoice',
        component: () => import(
          '@/views/platform/ICPS/supplier/supplierReceiptInvoice.vue'),
        meta: {
          title: '发票收取',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      /*绿舍智造*/
      /*智能排程*/
      {
        path: 'smartschedula',
        name: 'smartschedula',
        component: () => import(
          '@/views/platform/ICPS/smart/schedul/electronicfence.vue'),
        meta: {
          title: '电子围栏',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smartschedulb',
        name: 'smartschedulb',
        component: () => import(
          '@/views/platform/ICPS/smart/schedul/FigureManagement.vue'),
        meta: {
          title: '图算维护',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smartschedulc',
        name: 'smartschedulc',
        component: () => import(
          '@/views/platform/ICPS/smart/schedul/planreview/planreview.vue'),
        meta: {
          title: '计划审核',
          system: 'basicSite'
        }
      },
      {
        path: 'surplusFlow',
        name: 'surplusFlow',
        component: () => import(
          '@/views/platform/ICPS/smart/schedul/planreview/surplusFlow.vue'),
        meta: {
          title: '富余量审批',
          system: 'basicSite'
        }
      },
      {
        path: 'dockPlan',
        name: 'dockPlan',
        component: () => import(
          '@/views/platform/ICPS/smart/schedul/dockPlan.vue'),
        meta: {
          title: '对接订单',
          system: 'basicSite'
        }
      },
      {
        path: 'smartscheduld',
        name: 'smartscheduld',
        component: () => import(
          '@/views/platform/ICPS/smart/schedul/productionschedule/productionschedule.vue'),
        meta: {
          title: '生产排程',
          system: 'basicSite',
          keepAlive: true,
        }
      },
      {
        path: 'sign_smartscheduld',
        name: 'sign_smartscheduld',
        component: () => import(
          '@/views/platform/ICPS/smart/flowcomponent/sign_smartscheduld.vue'),
        meta: {
          title: '生产调整审批',
          system: 'basicSite',
        }
      },
      {
        path: 'smartschedule',
        name: 'smartschedule',
        component: () => import(
          '@/views/platform/ICPS/smart/schedul/capacityOfStatistical/capacityOfStatistical.vue'),
        meta: {
          title: '产量统计',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smartschedulf',
        name: 'smartschedulf',
        component: () => import(
          '@/views/platform/ICPS/smart/schedul/pumpOperation.vue'),
        meta: {
          title: '泵送作业',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smartschedulg',
        name: 'smartschedulg',
        component: () => import(
          '@/views/platform/ICPS/smart/schedul/exceptionHandling.vue'),
        meta: {
          title: '异常处理',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'penaltyLedger',
        name: 'penaltyLedger',
        component: () => import(
          '@/views/platform/ICPS/smart/penaltyLedger.vue'),
        meta: {
          title: '处罚台账',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'adjustQuantity',
        name: 'adjustQuantity',
        component: () => import(
          '@/views/platform/ICPS/smart/adjustQuantity.vue'),
        meta: {
          title: '调量管理',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'adjustQuantity_sign',
        name: 'adjustQuantity_sign',
        component: () => import(
          '@/views/platform/ICPS/smart/adjustQuantity_sign.vue'),
        meta: {
          title: '调量管理审批',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smartschedulh',
        name: 'smartschedulh',
        component: () => import(
          '@/views/platform/ICPS/smart/schedul/purchasingApplication.vue'),
        meta: {
          title: '采购申请',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smartscheduli',
        name: 'smartscheduli',
        component: () => import(
          '@/views/platform/ICPS/smart/schedul/pumpScheduling.vue'),
        meta: {
          title: '泵机调度',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smartschedulj',
        name: 'smartschedulj',
        component: () => import(
          '@/views/platform/ICPS/smart/schedul/productionScheduling.vue'),
        meta: {
          title: '生产调度',
          system: 'basicSite',
          keepAlive: true,
        }
      },
      {
        path: 'productTransport',
        name: 'productTransport',
        component: () => import(
          '@/views/platform/ICPS/smart/schedul/productTransport.vue'),
        meta: {
          title: '生产运输',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'carLineInfo',
        name: 'carLineInfo',
        component: () => import(
          '@/views/platform/ICPS/smart/schedul/carLineInfo.vue'),
        meta: {
          title: '车辆排队信息',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'surplusMaterials',
        name: 'surplusMaterials',
        component: () => import(
          '@/views/platform/ICPS/smart/schedul/surplusMaterials.vue'),
        meta: {
          title: '余料处理',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'productInfo',
        name: 'productInfo',
        component: () => import(
          '@/views/platform/ICPS/smart/schedul/productInfo.vue'),
        meta: {
          title: '在产信息',
          system: 'basicSite',
          keepAlive: true,
        }
      },
      {
        path: 'turningMaterials',
        name: 'turningMaterials',
        component: () => import(
          '@/views/platform/ICPS/smart/schedul/turningMaterials.vue'),
        meta: {
          title: '翻料处理',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'planDetail',
        name: 'planDetail',
        component: () => import(
          '@/views/platform/ICPS/smart/schedul/planDetail.vue'),
        meta: {
          title: '计划明细',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'logisticstable',
        name: 'WLGZB',
        component: () => import(
          '@/views/platform/ICPS/smart/schedul/logisticsTable.vue'),
        meta: {
          title: '物流明细',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'sign_smartschedulj',
        name: 'sign_smartschedulj',
        component: () => import(
          '@/views/platform/ICPS/smart/flowcomponent/sign_smartschedulj.vue'),
        meta: {
          title: '生产调度异常处理审批',
          system: 'basicSite',
        }
      },
      {
        path: 'smartschedulk',
        name: 'smartschedulk',
        component: () => import(
          '@/views/platform/ICPS/smart/schedul/transportationMap.vue'),
        meta: {
          title: '运输地图',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'gpsDevice',
        name: 'gpsDevice',
        component: () => import(
          '@/views/platform/ICPS/smart/schedul/gpsDevice.vue'),
        meta: {
          title: 'GPS设备',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'carDispatch',
        name: 'carDispatch',
        component: () => import(
          '@/views/platform/ICPS/smart/schedul/carDispatch.vue'),
        meta: {
          title: '罐车调度',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'carOut',
        name: 'carOut',
        component: () => import(
          '@/views/platform/ICPS/smart/schedul/carOut.vue'),
        meta: {
          title: '罐车出站',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'carInner',
        name: 'carInner',
        component: () => import(
          '@/views/platform/ICPS/smart/schedul/carInner.vue'),
        meta: {
          title: '罐车回站',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'tareTask',
        name: 'tareTask',
        component: () => import(
          '@/views/platform/ICPS/smart/schedul/tareTask.vue'),
        meta: {
          title: '皮重任务',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smartschedul_frontLog',
        name: 'smartschedul_frontLog',
        component: () => import(
          '@/views/platform/ICPS/smart/schedul/frontLog.vue'),
        meta: {
          title: '前场日志',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'warehouseControl',
        name: 'warehouseControl',
        component: () => import(
          '@/views/platform/ICPS/smart/warehouseControl.vue'),
        meta: {
          title: '库存仓控制',
          system: 'basicSite',
          // keepAlive: false,
        }
      },
      {
        path: 'smartstocksake',
        name: 'smartstocksake',
        component: () => import(
          '@/views/platform/ICPS/smart/stocksake.vue'),
        meta: {
          title: '库存维护',
          system: 'basicSite',
          // keepAlive: false,
        }
      },
      {
        path: 'environmentalMonitor',
        name: 'environmentalMonitor',
        // component: () => import(
        //   '@/views/platform/ICPS/smart/environmentalMonitor.vue'),
        component: () => import(
          '@/views/platform/ICPS/smart/environmentalMonitor/index.vue'),
        meta: {
          title: '环境监测',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'sign_stocksake1',
        name: 'sign_stocksake1',
        component: () => import(
          '@/views/platform/ICPS/smart/flowcomponent/sign_stocksake1.vue'),
        meta: {
          title: '库存盘点审批',
          system: 'basicSite',
        }
      },
      {
        path: 'sign_stocksake2',
        name: 'sign_stocksake2',
        component: () => import(
          '@/views/platform/ICPS/smart/flowcomponent/sign_stocksake2.vue'),
        meta: {
          title: '库存调拨审批',
          system: 'basicSite',
        }
      },
      /**
       * @Description: 原物料品质检验
       * @Param: 
       * @Author: wangwangwang
       */
      {
        path: 'fastcheckout',
        name: 'fastcheckout',
        component: () => import(
          '@/views/platform/ICPS/smart/materialcheckout/fastcheckout.vue'),
        meta: {
          title: '快速检验',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      /**
       * @Description: 检测审批
       * @Param: 
       * @Author: wangwangwang
       */
      {
        path: 'checkflows',
        name: 'checkflows',
        component: () => import(
          '@/views/platform/ICPS/smart/flowcomponent/CheckFlows.vue'),
        meta: {
          title: '原物料检测审批',
          system: 'basicSite',
        }
      },
      {
        path: 'checkflows2',
        name: 'checkflows2',
        component: () => import(
          '@/views/platform/ICPS/smart/flowcomponent/CheckFlows2.vue'),
        meta: {
          title: '混凝土检测审批',
          system: 'basicSite',
        }
      },
      {
        path: 'SpringbackCheck',
        name: 'SpringbackCheck',
        component: () => import(
          '@/views/platform/ICPS/basicConfig/SpringbackCheck.vue'),
        meta: {
          title: '回弹检测审批',
          system: 'basicSite',
        }
      },
      {
        path: 'ExceptionsApply1',
        name: 'ExceptionsApply1',
        component: () => import(
          '@/views/platform/ICPS/smart/flowcomponent/ExceptionsApply1.vue'),
        meta: {
          title: '泵工异常申报',
          system: 'basicSite',
        }
      },
      {
        path: 'ExceptionsApply2',
        name: 'ExceptionsApply2',
        component: () => import(
          '@/views/platform/ICPS/smart/flowcomponent/ExceptionsApply2.vue'),
        meta: {
          title: '前场工长异常申报',
          system: 'basicSite',
        }
      },
      {
        path: 'ExceptionsApply3',
        name: 'ExceptionsApply3',
        component: () => import(
          '@/views/platform/ICPS/smart/flowcomponent/ExceptionsApply3.vue'),
        meta: {
          title: '罐车司机异常申报',
          system: 'basicSite',
        }
      },
      {
        path: 'batchcheckout',
        name: 'batchcheckout',
        component: () => import(
          '@/views/platform/ICPS/smart/materialcheckout/batchcheckout.vue'),
        meta: {
          title: '批次检验',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'recheckout',
        name: 'recheckout',
        component: () => import(
          '@/views/platform/ICPS/smart/materialcheckout/recheckout.vue'),
        meta: {
          title: '原物料复检',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'spotcheckout',
        name: 'spotcheckout',
        component: () => import(
          '@/views/platform/ICPS/smart/materialcheckout/spotcheckout.vue'),
        meta: {
          title: '原物料抽检',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'othercheckout',
        name: 'othercheckout',
        component: () => import(
          '@/views/platform/ICPS/smart/materialcheckout/othercheckout.vue'),
        meta: {
          title: '原物料其他检验',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'inscheckout',
        name: 'inscheckout',
        component: () => import(
          '@/views/platform/ICPS/smart/materialcheckout/inscheckout.vue'),
        meta: {
          title: '原物料送检',
          system: 'inscheckout',
          keepAlive: false,
        }
      },
      {
        path: 'specheckout',
        name: 'specheckout',
        component: () => import(
          '@/views/platform/ICPS/smart/materialcheckout/specheckout.vue'),
        meta: {
          title: '见证取样检验',
          system: 'specheckout',
          keepAlive: false,
        }
      },
      {
        path: 'cementMortar',
        name: 'cementMortar',
        component: () => import(
          '@/views/platform/ICPS/smart/materialcheckout/cementMortar.vue'),
        meta: {
          title: '水泥胶砂基准强度',
          system: 'cementMortar',
          keepAlive: false,
        }
      },
      {
        path: 'entercheckout',
        name: 'entercheckout',
        component: () => import(
          '@/views/platform/ICPS/smart/soiltest/entercheckout.vue'),
        meta: {
          title: '出场检验',
          system: 'basicSite',
          keepAlive: true,
        }
      },
      {
        path: 'concretecheckout',
        name: 'concretecheckout',
        component: () => import(
          '@/views/platform/ICPS/smart/soiltest/concretecheckout.vue'),
        meta: {
          title: '混凝土其他检验',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smartsoiltesta',
        name: 'smartsoiltesta',
        component: () => import(
          '@/views/platform/ICPS/smart/soiltest/a.vue'),
        meta: {
          title: '回弹检验',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smartsoiltesta_a',
        name: 'smartsoiltesta_a',
        component: () => import(
          '@/views/platform/ICPS/smart/soiltest/a_a.vue'),
        meta: {
          title: '回弹记录',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smartsoiltestb',
        name: 'smartsoiltestb',
        component: () => import(
          '@/views/platform/ICPS/smart/soiltest/b.vue'),
        meta: {
          title: '回弹养护作业',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      
      {
        path: 'ThirdCheck1',
        name: 'ThirdCheck1',
        component: () => import(
          '@/views/platform/ICPS/smart/soiltest/flowcomponent/ThirdCheck1.vue'),
        meta: {
          title: '原物料三方检测审批',
          system: 'basicSite',
        }
      },
      {
        path: 'ThirdCheck2',
        name: 'ThirdCheck2',
        component: () => import(
          '@/views/platform/ICPS/smart/soiltest/flowcomponent/ThirdCheck2.vue'),
        meta: {
          title: '混凝土三方检测审批',
          system: 'basicSite',
        }
      },
      {
        path: 'smarmix',
        name: 'smarmix',
        component: () => import(
          '@/views/platform/ICPS/smart/mix.vue'),
        meta: {
          title: '实验配合比库',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smartdata',
        name: 'smartdata',
        component: () => import(
          '@/views/platform/ICPS/smart/data.vue'),
        meta: {
          title: '交工数据管理',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smartsoiltestc',
        name: 'smartsoiltestc',
        component: () => import(
          '@/views/platform/ICPS/smart/soiltest/c.vue'),
        meta: {
          title: '三方检测报告',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'reportService',
        name: 'reportService',
        component: () => import(
          '@/views/platform/ICPS/smart/reportService.vue'),
        meta: {
          title: '报告维护',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'reporSelfCheck',
        name: 'reporSelfCheck',
        component: () => import(
          '@/views/platform/ICPS/smart/reporSelfCheck.vue'),
        meta: {
          title: '自检报告库',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'sign_smartdata',
        name: 'sign_smartdata',
        component: () => import(
          '@/views/platform/ICPS/smart/components_data/sign_data.vue'),
        meta: {
          title: '交工资料审批',
          system: 'basicSite'
        }
      },
      {
        path: 'smartdataPlan',
        name: 'smartdataPlan',
        component: () => import(
          '@/views/platform/ICPS/smart/components_data/dataPlan.vue'),
        meta: {
          title: '查看计划',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smartwatertest',
        name: 'smartwatertest',
        component: () => import(
          '@/views/platform/ICPS/smart/watertest.vue'),
        meta: {
          title: '浆水检验',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smartouta',
        name: 'smartouta',
        component: () => import(
          '@/views/platform/ICPS/smart/out/a.vue'),
        meta: {
          title: '需求中心',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      /**特材库管理*/
      {
        path: 'smart_specialmaterial_car',
        name: 'smart_specialmaterial_car',
        component: () => import(
          '@/views/platform/ICPS/smart/specialmaterial/car.vue'),
        meta: {
          title: '车辆维护',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smart_specialmaterial_productProcessing',
        name: 'smart_specialmaterial_productProcessing',
        component: () => import(
          '@/views/platform/ICPS/smart/specialmaterial/productProcessing.vue'),
        meta: {
          title: '成品代加工费',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smart_specialmaterial_product',
        name: 'smart_specialmaterial_product',
        component: () => import(
          '@/views/platform/ICPS/smart/specialmaterial/product.vue'),
        meta: {
          title: '特材成品管理',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smart_specialmaterial_material',
        name: 'smart_specialmaterial_material',
        component: () => import(
          '@/views/platform/ICPS/smart/specialmaterial/material.vue'),
        meta: {
          title: '特材原料管理',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smart_specialmaterial_supplier',
        name: 'smart_specialmaterial_supplier',
        component: () => import(
          '@/views/platform/ICPS/smart/specialmaterial/supplier.vue'),
        meta: {
          title: '特材供应商管理',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smart_specialmaterial_Deplan',
        name: 'smart_specialmaterial_Deplan',
        component: () => import(
          '@/views/platform/ICPS/smart/specialmaterial/Deplan.vue'),
        meta: {
          title: '需求计划',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smart_specialmaterial_prodplan',
        name: 'smart_specialmaterial_prodplan',
        component: () => import(
          '@/views/platform/ICPS/smart/specialmaterial/prodplan.vue'),
        meta: {
          title: '生产计划',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'SpecialMaterialStatistics',
        name: 'SpecialMaterialStatistics',
        component: () => import(
          '@/views/platform/ICPS/smart/specialmaterial/SpecialMaterialStatistics.vue'),
        meta: {
          title: '特材交易统计',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'specialMaterialOutbound',
        name: 'specialMaterialOutbound',
        component: () => import(
          '@/views/platform/ICPS/smart/specialmaterial/specialMaterialOutbound.vue'),
        meta: {
          title: '特材出库',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smart_specialmaterial_shiplist',
        name: 'smart_specialmaterial_shiplist',
        component: () => import(
          '@/views/platform/ICPS/smart/specialmaterial/shiplist.vue'),
        meta: {
          title: '特材运输清单',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smart_specialmaterial_income',
        name: 'smart_specialmaterial_income',
        component: () => import(
          '@/views/platform/ICPS/smart/specialmaterial/income.vue'),
        meta: {
          title: '供应商来料',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smart_specialmaterial_quality',
        name: 'smart_specialmaterial_quality',
        component: () => import(
          '@/views/platform/ICPS/smart/specialmaterial/quality.vue'),
        meta: {
          title: '特材质量参数',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smart_specialmaterial_test',
        name: 'smart_specialmaterial_test',
        component: () => import(
          '@/views/platform/ICPS/smart/specialmaterial/test.vue'),
        meta: {
          title: '特材原料检验',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smart_specialmaterial_retest',
        name: 'smart_specialmaterial_retest',
        component: () => import(
          '@/views/platform/ICPS/smart/specialmaterial/retest.vue'),
        meta: {
          title: '特材原料复检',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smart_specialmaterial_incometest',
        name: 'smart_specialmaterial_incometest',
        component: () => import(
          '@/views/platform/ICPS/smart/specialmaterial/incometest.vue'),
        meta: {
          title: '特材成品入库检验',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smart_specialmaterial_incomeretest',
        name: 'smart_specialmaterial_incomeretest',
        component: () => import(
          '@/views/platform/ICPS/smart/specialmaterial/incomeretest.vue'),
        meta: {
          title: '特材成品复验',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'SpecialCheckFlows',
        name: 'SpecialCheckFlows',
        component: () => import(
          '@/views/platform/ICPS/smart/flowcomponent/SpecialCheckFlows.vue'),
        meta: {
          title: '特材检测审批',
          system: 'basicSite'
        }
      },
      /**材料管理*/
      {
        path: 'smartConfig',
        name: 'smartConfig',
        component: () => import(
          '@/views/platform/ICPS/smart/warehouse/smartConfig.vue'),
        meta: {
          title: '特材复配',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      /**仓库管理*/
      {
        path: 'smart_warehouseLIM',
        name: 'smart_warehouseLIM',
        component: () => import(
          '@/views/platform/ICPS/smart/warehouse/LIM.vue'),
        meta: {
          title: '液位仪',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smart_warehouseADRN',
        name: 'smart_warehouseADRN',
        component: () => import(
          '@/views/platform/ICPS/smart/warehouse/ADRN.vue'),
        meta: {
          title: '外加剂返料',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'sign_ADRN',
        name: 'sign_ADRN',
        component: () => import(
          '@/views/platform/ICPS/smart/flowcomponent/sign_ADRN.vue'),
        meta: {
          title: '外加剂返料审批',
          system: 'basicSite'
        }
      },
      /*积分管理*/
      {
        path: 'smart_integral_set',
        name: 'smart_integral_set',
        component: () => import(
          '@/views/platform/ICPS/smart/smartIntegral/smartIntegralSet.vue'),
        meta: {
          title: '积分维护',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'smart_integral_user',
        name: 'smart_integral_user',
        component: () => import(
          '@/views/platform/ICPS/smart/smartIntegral/smartIntegralUser.vue'),
        meta: {
          title: '用户积分',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      /*订单管理*/
      {
        path: 'smartoutb',
        name: 'smartoutb',
        component: () => import(
          '@/views/platform/ICPS/smart/out/b.vue'),
        meta: {
          title: '订单管理',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      /*绿舍优服*/
      /*客户评价*/
      {
        path: 'besSera',
        name: 'besSera',
        component: () => import(
          '@/views/platform/ICPS/besSer/a.vue'),
        meta: {
          title: '客户评价',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      /*周材管理*/
      {
        path: 'besSer_WMinventory',
        name: 'besSer_WMinventory',
        component: () => import(
          '@/views/platform/ICPS/besSer/WMmanagement/inventory.vue'),
        meta: {
          title: '周材库存',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'besSer_WMoutbound',
        name: 'besSer_WMoutbound',
        component: () => import(
          '@/views/platform/ICPS/besSer/WMmanagement/outbound.vue'),
        meta: {
          title: '周材出库',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'besSer_WMinstorage',
        name: 'besSer_WMinstorage',
        component: () => import(
          '@/views/platform/ICPS/besSer/WMmanagement/instorage.vue'),
        meta: {
          title: '周材入库',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'besSer_WMrecycling',
        name: 'besSer_WMrecycling',
        component: () => import(
          '@/views/platform/ICPS/besSer/WMmanagement/recycling.vue'),
        meta: {
          title: '周材回收',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'besSer_WMharvest',
        name: 'besSer_WMharvest',
        component: () => import(
          '@/views/platform/ICPS/besSer/WMmanagement/harvest.vue'),
        meta: {
          title: '周材采购',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'besSer_WMscrap',
        name: 'besSer_WMscrap',
        component: () => import(
          '@/views/platform/ICPS/besSer/WMmanagement/scrap.vue'),
        meta: {
          title: '周材报废',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'materialScrap',
        name: 'materialScrap',
        component: () => import(
          '@/views/platform/ICPS/besSer/WMmanagement/materialScrap.vue'),
        meta: {
          title: '周材报废审批',
          system: 'basicSite',
        }
      },
      {
        path: 'besSer_WMPMDM',
        name: 'besSer_WMPMDM',
        component: () => import(
          '@/views/platform/ICPS/besSer/WMmanagement/PMDM.vue'),
        meta: {
          title: '泵送难度模型',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      /*绿舍慧算*/
      {
        path: 'Wise_material',
        name: 'Wise_material',
        component: () => import(
          '@/views/platform/ICPS/Wise/material.vue'),
        meta: {
          title: '原物料结算',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'sign_material',
        name: 'sign_material',
        component: () => import(
          '@/views/platform/ICPS/Wise/sign/sign_material.vue'),
        meta: {
          title: '原物料结算审批',
          system: 'basicSite',
        }
      },
      {
        path: 'Wise_concrete',
        name: 'Wise_concrete',
        component: () => import(
          '@/views/platform/ICPS/Wise/concrete.vue'),
        meta: {
          title: '混凝土结算',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'concretePrice',
        name: 'concretePrice',
        component: () => import(
          '@/views/platform/ICPS/Wise/concretePrice.vue'),
        meta: {
          title: '混凝土结算价',
          system: 'basicSite',
          keepAlive: true,
        }
      },
      {
        path: 'concretePriceList',
        name: 'concretePriceList',
        component: () => import(
          '@/views/platform/ICPS/Wise/concretePriceList.vue'),
        meta: {
          title: '混凝土结算价-周期列表',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'concretePricePeriod',
        name: 'concretePricePeriod',
        component: () => import(
          '@/views/platform/ICPS/Wise/concretePricePeriod.vue'),
        meta: {
          title: '混凝土结算价-生成列表',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'sign_concrete',
        name: 'sign_concrete',
        component: () => import(
          '@/views/platform/ICPS/Wise/sign/sign_concrete.vue'),
        meta: {
          title: '混凝土结算审批',
          system: 'basicSite',
        }
      },
      {
        path: 'Wise_rentunit1',
        name: 'Wise_rentunit1',
        component: () => import(
          '@/views/platform/ICPS/Wise/Wise_rentunit/Wise_rentunit1.vue'),
        meta: {
          title: '原物料运输结算',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'sign_Wise_rentunit1',
        name: 'sign_Wise_rentunit1',
        component: () => import(
          '@/views/platform/ICPS/Wise/sign/sign_Wise_rentunit1.vue'),
        meta: {
          title: '原物料运输结算审批',
          system: 'basicSite',
        }
      },
      {
        path: 'Wise_rentunit2',
        name: 'Wise_rentunit2',
        component: () => import(
          '@/views/platform/ICPS/Wise/Wise_rentunit/Wise_rentunit2.vue'),
        meta: {
          title: '混凝土运输结算',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'sign_Wise_rentunit2',
        name: 'sign_Wise_rentunit2',
        component: () => import(
          '@/views/platform/ICPS/Wise/sign/sign_Wise_rentunit2.vue'),
        meta: {
          title: '混凝土运输结算审批',
          system: 'basicSite',
        }
      },
      {
        path: 'Wise_rentunit3',
        name: 'Wise_rentunit3',
        component: () => import(
          '@/views/platform/ICPS/Wise/Wise_rentunit/Wise_rentunit3.vue'),
        meta: {
          title: '泵送作业结算',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'sign_Wise_rentunit3',
        name: 'sign_Wise_rentunit3',
        component: () => import(
          '@/views/platform/ICPS/Wise/sign/sign_Wise_rentunit3.vue'),
        meta: {
          title: '泵送作业结算审批',
          system: 'basicSite',
        }
      },
      {
        path: 'Wise_rentunit4',
        name: 'Wise_rentunit4',
        component: () => import(
          '@/views/platform/ICPS/Wise/Wise_rentunit/Wise_rentunit4.vue'),
        meta: {
          title: '特材运输结算',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'sign_Wise_rentunit4',
        name: 'sign_Wise_rentunit4',
        component: () => import(
          '@/views/platform/ICPS/Wise/sign/sign_Wise_rentunit4.vue'),
        meta: {
          title: '特材运输结算审批',
          system: 'basicSite',
        }
      },
      {
        path: 'Wise_rentunit5',
        name: 'Wise_rentunit5',
        component: () => import(
          '@/views/platform/ICPS/Wise/Wise_rentunit/Wise_rentunit5.vue'),
        meta: {
          title: '特材加工结算',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'sign_Wise_rentunit5',
        name: 'sign_Wise_rentunit5',
        component: () => import(
          '@/views/platform/ICPS/Wise/sign/sign_Wise_rentunit5.vue'),
        meta: {
          title: '特材加工结算审批',
          system: 'basicSite',
        }
      },


      {
        path: 'Wise_contactsbusiness1',
        name: 'Wise_contactsbusiness1',
        component: () => import(
          '@/views/platform/ICPS/Wise/Wise_contactsbusiness/Wise_contactsbusiness1.vue'),
        meta: {
          title: '外协业务结算',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'sign_Wise_contactsbusiness1',
        name: 'sign_Wise_contactsbusiness1',
        component: () => import(
          '@/views/platform/ICPS/Wise/sign/sign_Wise_contactsbusiness1.vue'),
        meta: {
          title: '外协业务结算审批',
          system: 'basicSite',
        }
      },
      {
        path: 'Wise_contactsbusiness2',
        name: 'Wise_contactsbusiness2',
        component: () => import(
          '@/views/platform/ICPS/Wise/Wise_contactsbusiness/Wise_contactsbusiness2.vue'),
        meta: {
          title: '协外业务结算',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'sign_Wise_contactsbusiness2',
        name: 'sign_Wise_contactsbusiness2',
        component: () => import(
          '@/views/platform/ICPS/Wise/sign/sign_Wise_contactsbusiness2.vue'),
        meta: {
          title: '协外业务结算审批',
          system: 'basicSite',
        }
      },
      {
        path: 'contactUnitRecord',
        name: 'contactUnitRecord',
        component: () => import(
          '@/views/platform/ICPS/Wise/Wise_contactsbusiness/contactUnitRecord.vue'),
        meta: {
          title: '结算价',
          system: 'basicSite',
          keepAlive: true,
        }
      },
      {
        path: 'contactList',
        name: 'contactList',
        component: () => import(
          '@/views/platform/ICPS/Wise/Wise_contactsbusiness/contactList.vue'),
        meta: {
          title: '周期列表',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'contactRecordList',
        name: 'contactRecordList',
        component: () => import(
          '@/views/platform/ICPS/Wise/Wise_contactsbusiness/contactRecordList.vue'),
        meta: {
          title: '生成列表',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'Wise_internalunit',
        name: 'Wise_internalunit',
        component: () => import(
          '@/views/platform/ICPS/Wise/internalunit.vue'),
        meta: {
          title: '内部单位结算',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'sign_internalunit',
        name: 'sign_internalunit',
        component: () => import(
          '@/views/platform/ICPS/Wise/sign/sign_internalunit.vue'),
        meta: {
          title: '内部单位结算审核',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'Wise_infrastructure',
        name: 'Wise_infrastructure',
        component: () => import(
          '@/views/platform/ICPS/Wise/infrastructure.vue'),
        meta: {
          title: '基建及设备项目结算',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'sign_infrastructure',
        name: 'sign_infrastructure',
        component: () => import(
          '@/views/platform/ICPS/Wise/sign/sign_infrastructure.vue'),
        meta: {
          title: '基建及设备项目结算审核',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'settlementTask',
        name: 'settlementTask',
        component: () => import(
          '@/views/platform/ICPS/Wise/settlementTask.vue'),
        meta: {
          title: '结算任务',
          system: 'basicSite',
          keepAlive: false,
        }
      }, {
        path: 'settlementTaskSure',
        name: 'settlementTaskSure',
        component: () => import(
          '@/views/platform/ICPS/Wise/settlementTaskSure.vue'),
        meta: {
          title: '结算任务确认',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'sign_settlementTask',
        name: 'sign_settlementTask',
        component: () => import(
          '@/views/platform/ICPS/Wise/sign/sign_settlementTask.vue'),
        meta: {
          title: '结算任务审核',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      {
        path: 'sign_settlementTask_back',
        name: 'sign_settlementTask_back',
        component: () => import(
          '@/views/platform/ICPS/Wise/sign/sign_settlementTaskBack.vue'),
        meta: {
          title: '结算任务撤回审核',
          system: 'basicSite',
          keepAlive: false,
        }
      },
      /**看板*/
      {
        path: 'board_datasource',
        name: 'board_datasource',
        component: () => import(
          '@/views/platform/ICPS/board/datasource.vue'),
        meta: {
          title: '看板数据源',
          system: 'basicSite',
        }
      },
      {
        path: 'board_Salesofkanban',
        name: 'board_Salesofkanban',
        component: () => import(
          '@/views/platform/ICPS/board/Salesofkanban.vue'),
        meta: {
          title: '看板',
          system: 'basicSite',
        }
      },
      {
        path: 'editBoard',
        name: 'editBoard',
        component: () => import(
          '@/views/platform/ICPS/board/editBoard.vue'),
        meta: {
          title: '编辑看板',
          system: 'basicSite',
        }
      },
      {
        path: 'insideUrl',
        name: 'insideUrl',
        component: () => import(
          '@/views/platform/ICPS/board/insideUrl.vue'),
        meta: {
          title: '内部链接',
          system: 'basicSite',
        }
      },
      /**采购*/
      {
        path: 'GHnumberPaymentpayment',
        name: 'GHnumberPaymentpayment',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/payment/payment.vue'),
        meta: {
          title: '付款',
          system: 'basicSite',
        }
      },
      {
        path: 'GHnumberPaymentprocurement',
        name: 'GHnumberPaymentprocurement',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/payment/procurement.vue'),
        meta: {
          title: '自开票据',
          system: 'basicSite',
        }
      },{
        path: 'GHnumberPaymentplan',
        name: 'GHnumberPaymentplan',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/payment/planForPayment.vue'),
        meta: {
          title: '计划付款',
          system: 'basicSite',
        }
      },
      {
        path: 'GHnumberPaymentotherPayment',
        name: 'GHnumberPaymentotherPayment',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/payment/otherPayment.vue'),
        meta: {
          title: '其他付款',
          system: 'basicSite',
        }
      },
      {
        path: 'GHnumberPaymentotherReceipts',
        name: 'GHnumberPaymentotherReceipts',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/payment/otherReceipts.vue'),
        meta: {
          title: '其他收款',
          system: 'basicSite',
        }
      },
      {
        path: 'GHnumberPaymentassemblyReceipts',
        name: 'GHnumberPaymentassemblyReceipts',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/payment/assemblyReceipts.vue'),
        meta: {
          title: '装配式收款',
          system: 'basicSite',
        }
      },
      {
        path: 'GHnumberPaymentinvoiceManagement',
        name: 'GHnumberPaymentinvoiceManagement',
        component: () => import(
          '@/views/platform/ICPS/GHnumber/payment/invoiceManagement.vue'),
        meta: {
          title: '发票收取',
          system: 'basicSite',
        }
      },
      //共享对接
      {
        path: 'purchaseSaleStore',
        name: 'purchaseSaleStore',
        component: () => import(
          '@/views/platform/ICPS/Wise/docking/accountingSheet/purchaseSaleStore.vue'),
        meta: {
          title: '材料进销存',
          system: 'basicSite',
        }
      },
      {
        path: 'accountingSheet',
        name: 'accountingSheet',
        component: () => import(
          '@/views/platform/ICPS/Wise/docking/accountingSheet/accountingSheet.vue'),
        meta: {
          title: '业务记账单',
          system: 'basicSite',
        }
      },
      {
        path: 'accountingSheetDetail',
        name: 'accountingSheetDetail',
        component: () => import(
          '@/views/platform/ICPS/Wise/docking/accountingSheet/accountingSheetDetail.vue'),
        meta: {
          title: '业务记账单明细',
          system: 'basicSite',
        }
      },
      {
        path: 'purchaseSaleStoreDetail',
        name: 'purchaseSaleStoreDetail',
        component: () => import(
          '@/views/platform/ICPS/Wise/docking/accountingSheet/purchaseSaleStoreDetail.vue'),
        meta: {
          title: '材料进销存明细',
          system: 'basicSite',
        }
      }, 
      {
        path: 'accessoryMaterial',
        name: 'accessoryMaterial',
        component: () => import(
          '@/views/platform/ICPS/Wise/docking/accessorySheet/accessoryMaterial.vue'),
        meta: {
          title: '配件材料表',
          system: 'basicSite',
        }
      },
      {
        path: 'accessoryMaterialDetail',
        name: 'accessoryMaterialDetail',
        component: () => import(
          '@/views/platform/ICPS/Wise/docking/accessorySheet/accessoryMaterialDetail.vue'),
        meta: {
          title: '配件材料表明细',
          system: 'basicSite',
        }
      },
      {
        path: 'accessoryAccountingSheetDetail',
        name: 'accessoryAccountingSheetDetail',
        component: () => import(
          '@/views/platform/ICPS/Wise/docking/accessorySheet/accessoryAccountingSheetDetail.vue'),
        meta: {
          title: '业务记账单明细',
          system: 'basicSite',
        }
      },
      {
        path: 'supplierLedger',
        name: 'supplierLedger',
        component: () => import(
          '@/views/platform/ICPS/Wise/docking/supplierLedger.vue'),
        meta: {
          title: '供应商台账',
          system: 'basicSite',
        }
      },
      {
        path: 'saleMonthReport',
        name: 'saleMonthReport',
        component: () => import(
          '@/views/platform/ICPS/Wise/docking/incomeSheet/saleMonthReport.vue'),
        meta: {
          title: '销售月报',
          system: 'basicSite',
        }
      },
      {
        path: 'incomeSheet',
        name: 'incomeSheet',
        component: () => import(
          '@/views/platform/ICPS/Wise/docking/incomeSheet/incomeSheet.vue'),
        meta: {
          title: '收入报账单',
          system: 'basicSite',
        }
      },
      {
        path: 'incomeSheetDetail',
        name: 'incomeSheetDetail',
        component: () => import(
          '@/views/platform/ICPS/Wise/docking/incomeSheet/incomeSheetDetail.vue'),
        meta: {
          title: '收入报账单明细',
          system: 'basicSite',
        }
      },
      {
        path: 'saleMonthReportDetail',
        name: 'saleMonthReportDetail',
        component: () => import(
          '@/views/platform/ICPS/Wise/docking/incomeSheet/saleMonthReportDetail.vue'),
        meta: {
          title: '销售月报明细',
          system: 'basicSite',
        }
      },
    ],
  }],
}]